import {
  utStudent,
  utTeacher,
  utMSite,
  utMSystem,
  utEJSystem
} from '../api/v1.commom.login.ts';

let managerRouter = [
  // 考评员
  {
    path: '/wlx/appraiser',
    name: 'appraiserManager',
    props: true,
    meta: {
      requiresAuth: true,
    },
    redirect: {name: 'lecturerManager'},
    component: () => import ('page/xSchool/managerCom/appraiserSystem.vue'),
    children: [
      // {
      //   path: 'TeacherAppraiser',
      //   name: 'TeacherAppraiser',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '考评员审核',
      //   },
      //   component: () => import ('page/xSchool/manager/TeacherAppraiser.vue'),
      // },
      {
        path: 'lecturer',
        name: 'lecturerManager',
        props: true,
        redirect: {name: 'TeacherAudit'},
        meta: {
          userType: [utMSystem,utEJSystem],
          requiresAuth: true,
          title: '教师申报管理',
        },
        component: () => import ('page/xSchool/56xSystemManager/lecturer.vue'),
        children: [
          {
            path: 'teaStandard',
            name: 'teaStandard',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '讲师申请标准',
            },
            component: () => import ('page/xSchool/manager/teaStandard.vue'),
          },
          {
            path: 'teaAudit',
            name: 'TeacherAudit',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '讲师审核',
            },
            component: () => import ('page/xSchool/manager/TeacherAudit.vue'),
          },
          {
            path: 'teaPeiXunData',
            name: 'teaPeiXunData',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '师资培训',
            },
            component: () => import ('page/xSchool/manager/teaPeiXunData.vue'),
          },
          //   {
          //     path: 'TeacherAppraiser',
          //     name: 'TeacherAppraiser',
          //     props: true,
          //     meta: {
          //       userType: [utMSystem,utEJSystem],
          //       requiresAuth: true,
          //       title: '考评员审核',
          //     },
          //     component: () =>
          //       import ('page/xSchool/manager/TeacherAppraiser.vue'),
          //   },
          {
            path: 'certificate',
            name: 'AuditCertificate',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '讲师考证审核',
            },
            component: () =>
              import ('page/xSchool/manager/AuditCertificate.vue'),
          },
          {
            path: 'avitve',
            name: 'TrainActivity',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '培训活动',
            },
            component: () => import ('page/xSchool/manager/TrainActivity.vue'),
          },
          {
            path: 'teaStandard/:certifiId/teaNode',
            name: 'attestationNode',
            props: true,
            meta: {
              userType: [utMSystem,utEJSystem],
              requiresAuth: true,
              title: '讲师认证节点',
            },
            component: () =>
              import ('page/xSchool/manager/attestationNode.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/wlx/metarial',
    name: 'metarialPublish',
    props: true,
    meta: {
      requiresAuth: true,
    },
    redirect: {name: 'studyCenterManage'},
    component: () => import ('page/xSchool/managerCom/metarialPublish.vue'),
    children: [
      {
        path: 'studyCenterManage',
        name: 'studyCenterManage',
        props: true,
        meta: {
          userType: [utMSystem,utEJSystem],
          requiresAuth: true,
          title: '学习中心管理',
        },
        redirect: {name: 'ShareManagement'},
        component: () =>
          import ('page/xSchool/56xSystemManager/studyCenterManage.vue'),
        children: [
          // {
          //   path: 'teaBook',
          //   name: 'teaBookList',
          //   props: true,
          //   meta: {
          //     userType: [utMSystem,utEJSystem],
          //     requiresAuth: true,
          //     title: '教材管理',
          //   },
          //   component: () =>
          //     import ('page/xSchool/teachingMaterial/teaBookList.vue'),
          // },
          // {
          //   path: '/system/:courseId/:folderId/ShareManagement',
          //   name: 'ShareManagement',
          //   props: true,
          //   meta: {
          //     title: '教材资源',
          //   },
          //   redirect: {name: 'teaShareManagementSource'},
          //   component: () =>
          //     import (
          //       'page/xSchool/teachingMaterial/teaManager/ShareManagement.vue'
          //     ),
          //   children: [
          //     {
          //       path: 'teaShareManagementSource', // 课件
          //       name: 'teaShareManagementSource',
          //       props: true,
          //       meta: {
          //         title: '课件',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/teaManager/ShareManagementSource.vue'
          //         ),
          //     },
          //     {
          //       path: 'teaShareManagementHomework', // 作业
          //       name: 'teaShareManagementHomework',
          //       props: true,
          //       meta: {
          //         title: '作业',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/teaManager/ShareManagementHomework.vue'
          //         ),
          //     },
          //     {
          //       path: 'teaShareManagementQuestion', // 题库
          //       name: 'teaShareManagementQuestion',
          //       props: true,
          //       meta: {
          //         title: '题库',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/ShareManagementQuestion.vue'
          //         ),
          //     },
          //     {
          //       path: ':knowledgeInfoId/teaSave', // 添加题目
          //       name: 'teaQuestionWarehouseAdd',
          //       props: true,
          //       meta: {
          //         title: '添加题目',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/QuestionWarehouseAdd.vue'
          //         ),
          //     },
          //     {
          //       path: ':knowledgeInfoId/teaEdit', // 修改题目
          //       name: 'teaQuestionWarehouseedit',
          //       props: true,
          //       meta: {
          //         title: '修改题目',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/QuestionWarehouseAdd.vue'
          //         ),
          //     },
          //     {
          //       path: 'teaShareManagementCatalogue', // 目录
          //       name: 'teaShareManagementCatalogue',
          //       props: true,
          //       meta: {
          //         title: '修改题目',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/teaManager/ShareManagementCatalogue.vue'
          //         ),
          //     },
          //     {
          //       path: 'teaShareManagementattached', // 辅页
          //       name: 'teaShareManagementattached',
          //       props: true,
          //       meta: {
          //         title: '辅页',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/teaManager/ShareManagementattached.vue'
          //         ),
          //     },
          //     {
          //       path: 'teaShareManagementinteraction', // 互动
          //       name: 'teaShareManagementinteraction',
          //       props: true,
          //       meta: {
          //         title: '互动',
          //       },
          //       component: () =>
          //         import (
          //           'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction.vue'
          //         ),
          //       children: [
          //         {
          //           path: 'teaShareDiscussCourse', // 分享互动--讨论
          //           name: 'teaShareDiscussCourse',
          //           props: true,
          //           meta: {
          //             title: '讨论',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareDiscussCourse.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareVoteCourse', // 分享互动--投票
          //           name: 'teaShareVoteCourse',
          //           props: true,
          //           meta: {
          //             title: '投票',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareVoteCourse.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareQuestion', // 分享互动--提问
          //           name: 'teaShareQuestion',
          //           props: true,
          //           meta: {
          //             title: '提问',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareQuestion.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareTest', // 分享互动--测验
          //           name: 'teaShareTest',
          //           props: true,
          //           meta: {
          //             title: '测验',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareTest.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareSurveyCourse', // 分享互动--问卷调查
          //           name: 'teaShareSurveyCourse',
          //           props: true,
          //           meta: {
          //             title: '问卷调查',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareSurveyCourse.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareBrainstormingCourse', // 分享互动--头脑风暴
          //           name: 'teaShareBrainstormingCourse',
          //           props: true,
          //           meta: {
          //             title: '头脑风暴',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareBrainstormingCourse.vue'
          //             ),
          //         },
          //         {
          //           path: 'teaShareQuestionnaireQuestion/:questionnaireId', // 分享互动--添加问卷调查
          //           name: 'teaShareQuestionnaireQuestion',
          //           props: true,
          //           meta: {
          //             title: '添加问卷调查',
          //           },
          //           component: () =>
          //             import (
          //               'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareQuestionnaireQuestion.vue'
          //             ),
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   path: '/system/:courseId/:paperId/teaHomework_bank',
          //   name: 'teaHomework_bank',
          //   props: true,
          //   meta: {
          //     title: '题库添加作业',
          //   },
          //   component: () =>
          //     import ('page/xSchool/teachingMaterial/Homework_bank.vue'),
          // },
          // {
          //   path: '/system/:courseId/:paperId/teaEnclosureQuestion',
          //   name: 'teaEnclosureQuestion',
          //   props: true,
          //   meta: {
          //     title: '题库添加附件作业',
          //   },
          //   component: () =>
          //     import (
          //       'page/xSchool/teachingMaterial/PaperEnclosureQuestion.vue'
          //     ),
          // },
          // {
          //   path: '/system/:courseId/:paperId/checkschoolehomework',
          //   name: 'checkschoolehomework',
          //   props: true,
          //   meta: {
          //     title: '查看题库作业',
          //   },
          //   component: () =>
          //     import ('page/xSchool/teachingMaterial/Checkhomework.vue'),
          // },
          // {
          //   path: '/system/:courseId/:paperId/checkschoolEnclosure',
          //   name: 'checkschoolEnclosure',
          //   props: true,
          //   meta: {
          //     title: '查看附件作业',
          //   },
          //   component: () =>
          //     import ('page/xSchool/teachingMaterial/CheckEnclosure.vue'),
          // },
          // {
          //   path: ':courseId/:questionnaireId/ShareSurveyCourseView', // 分享互动--问卷调查详情
          //   name: 'ShareSurveyCourseView',
          //   props: true,
          //   meta: {
          //     title: '查看问卷调查',
          //   },
          //   component: () =>
          //     import (
          //       'page/xSchool/teachingMaterial/teaManager/ShareManagementinteraction/ShareSurveyCourseView.vue'
          //     ),
          // },
          {
            path: 'videoList', // 串讲视频
            name: 'videoList',
            props: true,
            meta: {
              title: '串讲视频',
            },
            component: () =>
              import ('page/xSchool/56xSystemManager/videoList.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/wlx/projectApply',
    name: 'projectApplyManager',
    props: true,
    meta: {
      requiresAuth: true,
    },
    component: () => import ('page/xSchool/managerCom/projectApply.vue'),
    children:[
        // {
        //     path: 'pilot',
        //     name: 'pilotManager',
        //     props: true,
        //     meta: {
        //       userType: [utMSystem,utEJSystem],
        //       requiresAuth: true,
        //       title: '试点申报管理',
        //     },
        //     component: () =>
        //       import ('page/xSchool/56xSystemManager/pilotManager.vue'),
        // },
        // {
        //   path: 'adoptSchool',
        //   name: 'adoptSchool',
        //   props: true,
        //   meta: {
        //     userType: [utMSystem,utEJSystem],
        //     requiresAuth: true,
        //     title: '站点管理',
        //   },
        //   component: () =>
        //     import ('page/xSchool/manager/siteManager/adoptSchool.vue'),
        // },
        // {
        //   path: 'assessmentApply',
        //   name: 'assessmentApply',
        //   props: true,
        //   meta: {
        //     userType: [utMSystem,utEJSystem],
        //     requiresAuth: true,
        //     title: '考核站点申请',
        //   },
        //   component: () =>
        //     import ('page/xSchool/manager/siteManager/assessmentApply.vue'),
        // },
        // {
        //   path: 'provincialHead',
        //   name: 'provincialHead',
        //   props: true,
        //   meta: {
        //     userType: [utMSystem,utEJSystem],
        //     requiresAuth: true,
        //     title: '省级工作室',
        //   },
        //   component: () =>
        //     import ('page/xSchool/manager/siteManager/provincialHead.vue'),
        // },
        // {
        //   path: 'statistical',
        //   name: 'statistical',
        //   props: true,
        //   meta: {
        //     userType: [utMSystem,utEJSystem],
        //     requiresAuth: true,
        //     title: '毕业生就业统计',
        //   },
        //   component: () =>
        //     import ('page/xSchool/manager/siteManager/statistical.vue'),
        // },
        // {
        //   path: 'jobsNeed',
        //   name: 'jobsNeed',
        //   props: true,
        //   meta: {
        //     userType: [utMSystem,utEJSystem],
        //     requiresAuth: true,
        //     title: '招聘岗位信息',
        //   },
        //   component: () =>
        //     import ('page/xSchool/manager/siteManager/jobsNeed.vue'),
        // },
    ]
  },
  // 成绩/证书管理
  {
    path: '/wlx/stuResultMar',
    name: 'stuResultMar',
    props: true,
    meta: {
      requiresAuth: true,
    },
    redirect: {name: 'pilotManager'},
    component: () => import ('page/xSchool/managerCom/stuResultMar.vue'),
    children:[
      // {
      //   path: 'resultsManager',
      //   name: 'resultsManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '学生成绩管理',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/resultsManager.vue'),
      // },
      // {
      //   path: 'certificateManager',
      //   name: 'certificateManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '证书管理',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/certificateManager.vue'),
      // },
      // {
      //   path: 'certificateTypeManager',
      //   name: 'certificateTypeManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '证书类型设置',
      //   },
      //   component: () =>
      //     import (
      //       'page/xSchool/56xSystemManager/certificateTypeManager.vue'
      //     ),
      // }
    ]
  },
  // 考试申报
  {
    path: '/wlx/examManager',
    name: 'examManager',
    props: true,
    meta: {
      requiresAuth: true,
    },
    redirect: {name: 'pilotManager'},
    component: () => import ('page/xSchool/managerCom/examManager.vue'),
    children:[
      // {
      //   path: 'examDeclareManager',
      //   name: 'examDeclareManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '考试申报管理',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/examManager.vue'),
      // },
      // {
      //   path: 'examTime',
      //   name: 'examTime',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '考试批次管理',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/ExamTime.vue'),
      // },
      // {
      //   path: 'FileManager',
      //   name: 'FileManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '考试端地址',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/uploadFileManager.vue'),
      // },
      // {
      //   path: 'examInfoManager',
      //   name: 'examInfoManager',
      //   props: true,
      //   meta: {
      //     userType: [utMSystem,utEJSystem],
      //     requiresAuth: true,
      //     title: '考试信息管理',
      //   },
      //   component: () =>
      //     import ('page/xSchool/56xSystemManager/examInfoManager.vue'),
      // },
    ]
  }
];

export default managerRouter;
